// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  color: #333;
}

/* ===== Loading State ===== */
.loading-home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 1rem;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #00703C;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ===== Hero Section ===== */
.hero-section {
  position: relative;
  height: 85vh;
  overflow: hidden;
}

.hero-slider {
  position: relative;
  width: 100%;
  height: 100%;
}

.hero-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
}

.hero-image.active {
  opacity: 1;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.hero-content {
  text-align: center;
  color: white;
  padding: 2rem;
  max-width: 900px;
  animation: fadeInUp 1s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  line-height: 1.2;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 1.4rem;
  margin-bottom: 2rem;
  font-weight: 300;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  padding: 1rem 2.5rem;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-primary {
  background: #00703C;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 112, 60, 0.3);
}

.btn-primary:hover {
  background: #005a30;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 112, 60, 0.4);
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: white;
  color: #00703C;
  transform: translateY(-2px);
}

/* Slider Controls */
.slider-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.3);
  border: none;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 3;
  backdrop-filter: blur(8px);
}

.slider-btn:hover {
  background: rgba(255, 255, 255, 0.5);
  transform: translateY(-50%) scale(1.1);
}

.slider-btn.prev {
  left: 2rem;
}

.slider-btn.next {
  right: 2rem;
}

.slider-dots {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.75rem;
  z-index: 3;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.dot.active {
  background: white;
  width: 32px;
  border-radius: 6px;
}

/* ===== Stats Section ===== */
.stats-section {
  background: linear-gradient(135deg, #00703C 0%, #005a30 100%);
  padding: 3rem 1.5rem;
  color: white;
}

.stats-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.stat-card {
  text-align: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
}

.stat-number {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1.1rem;
  opacity: 0.9;
}

/* ===== Section Headers ===== */
.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-header h2 {
  color: #00703C;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.section-underline {
  width: 80px;
  height: 4px;
  background: linear-gradient(to right, #00703C, #00914f);
  margin: 0 auto;
  border-radius: 2px;
}

/* ===== Intro Section ===== */
.intro-section {
  padding: 5rem 1.5rem;
  max-width: 900px;
  margin: 0 auto;
}

.intro-text {
  font-size: 1.15rem;
  line-height: 1.8;
  color: #555;
  text-align: center;
}

.intro-text strong {
  color: #00703C;
  font-weight: 600;
}

/* ===== Features Section ===== */
.features-section {
  background: #f8f9fa;
  padding: 5rem 1.5rem;
}

.features-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.feature-card {
  background: white;
  padding: 2.5rem 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  text-align: center;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 30px rgba(0, 112, 60, 0.15);
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00703C 0%, #00914f 100%);
  border-radius: 50%;
  color: white;
}

.feature-card h3 {
  color: #00703C;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.feature-card p {
  color: #666;
  line-height: 1.7;
  font-size: 1rem;
}

/* ===== CTA Section ===== */
.cta-section {
  background: linear-gradient(135deg, #00703C 0%, #005a30 100%);
  padding: 5rem 1.5rem;
  text-align: center;
  color: white;
}

.cta-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.cta-content p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.95;
}

.cta-button {
  padding: 1.2rem 3rem;
  background: white;
  color: #00703C;
  border: none;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  gap: 1rem;
}

/* ===== Mission Section ===== */
.mission-section {
  padding: 5rem 1.5rem;
  background: white;
}

.mission-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 3rem;
}

.mission-card {
  padding: 3rem 2.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  border-left: 5px solid #00703C;
}

.mission-card h3 {
  color: #00703C;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
}

.mission-card p {
  color: #555;
  line-height: 1.8;
  font-size: 1.05rem;
}

/* ===== Responsive Design ===== */
@media (max-width: 768px) {
  .hero-section {
    height: 70vh;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .slider-btn {
    width: 40px;
    height: 40px;
  }

  .slider-btn.prev {
    left: 1rem;
  }

  .slider-btn.next {
    right: 1rem;
  }

  .stats-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .stat-number {
    font-size: 2.5rem;
  }

  .section-header h2 {
    font-size: 2rem;
  }

  .intro-section,
  .features-section,
  .cta-section,
  .mission-section {
    padding: 3rem 1rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .mission-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .cta-content h2 {
    font-size: 2rem;
  }

  .cta-content p {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.6rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .stat-number {
    font-size: 2rem;
  }

  .section-header h2 {
    font-size: 1.7rem;
  }

  .feature-icon {
    width: 60px;
    height: 60px;
  }

  .mission-card {
    padding: 2rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,gFAAgF;EAChF,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uDAAuD;EACvD,cAAc;EACd,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".home-container {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  color: #333;\n}\n\n/* ===== Loading State ===== */\n.loading-home {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  gap: 1rem;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #00703C;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ===== Hero Section ===== */\n.hero-section {\n  position: relative;\n  height: 85vh;\n  overflow: hidden;\n}\n\n.hero-slider {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.hero-image {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 1.2s ease-in-out;\n}\n\n.hero-image.active {\n  opacity: 1;\n}\n\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n.hero-content {\n  text-align: center;\n  color: white;\n  padding: 2rem;\n  max-width: 900px;\n  animation: fadeInUp 1s ease;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hero-title {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  line-height: 1.2;\n  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.hero-subtitle {\n  font-size: 1.4rem;\n  margin-bottom: 2rem;\n  font-weight: 300;\n  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 1rem 2.5rem;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.btn-primary {\n  background: #00703C;\n  color: white;\n  box-shadow: 0 4px 15px rgba(0, 112, 60, 0.3);\n}\n\n.btn-primary:hover {\n  background: #005a30;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 112, 60, 0.4);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: white;\n  border: 2px solid white;\n}\n\n.btn-secondary:hover {\n  background: white;\n  color: #00703C;\n  transform: translateY(-2px);\n}\n\n/* Slider Controls */\n.slider-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.3);\n  border: none;\n  color: white;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 3;\n  backdrop-filter: blur(8px);\n}\n\n.slider-btn:hover {\n  background: rgba(255, 255, 255, 0.5);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.slider-btn.prev {\n  left: 2rem;\n}\n\n.slider-btn.next {\n  right: 2rem;\n}\n\n.slider-dots {\n  position: absolute;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 0.75rem;\n  z-index: 3;\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.dot.active {\n  background: white;\n  width: 32px;\n  border-radius: 6px;\n}\n\n/* ===== Stats Section ===== */\n.stats-section {\n  background: linear-gradient(135deg, #00703C 0%, #005a30 100%);\n  padding: 3rem 1.5rem;\n  color: white;\n}\n\n.stats-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.stat-card {\n  text-align: center;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  transition: transform 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.stat-number {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.stat-label {\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n/* ===== Section Headers ===== */\n.section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.section-header h2 {\n  color: #00703C;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.section-underline {\n  width: 80px;\n  height: 4px;\n  background: linear-gradient(to right, #00703C, #00914f);\n  margin: 0 auto;\n  border-radius: 2px;\n}\n\n/* ===== Intro Section ===== */\n.intro-section {\n  padding: 5rem 1.5rem;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.intro-text {\n  font-size: 1.15rem;\n  line-height: 1.8;\n  color: #555;\n  text-align: center;\n}\n\n.intro-text strong {\n  color: #00703C;\n  font-weight: 600;\n}\n\n/* ===== Features Section ===== */\n.features-section {\n  background: #f8f9fa;\n  padding: 5rem 1.5rem;\n}\n\n.features-grid {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.feature-card {\n  background: white;\n  padding: 2.5rem 2rem;\n  border-radius: 16px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.feature-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 12px 30px rgba(0, 112, 60, 0.15);\n}\n\n.feature-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #00703C 0%, #00914f 100%);\n  border-radius: 50%;\n  color: white;\n}\n\n.feature-card h3 {\n  color: #00703C;\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.feature-card p {\n  color: #666;\n  line-height: 1.7;\n  font-size: 1rem;\n}\n\n/* ===== CTA Section ===== */\n.cta-section {\n  background: linear-gradient(135deg, #00703C 0%, #005a30 100%);\n  padding: 5rem 1.5rem;\n  text-align: center;\n  color: white;\n}\n\n.cta-content h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.cta-content p {\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n  opacity: 0.95;\n}\n\n.cta-button {\n  padding: 1.2rem 3rem;\n  background: white;\n  color: #00703C;\n  border: none;\n  border-radius: 50px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.cta-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n  gap: 1rem;\n}\n\n/* ===== Mission Section ===== */\n.mission-section {\n  padding: 5rem 1.5rem;\n  background: white;\n}\n\n.mission-grid {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 3rem;\n}\n\n.mission-card {\n  padding: 3rem 2.5rem;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 16px;\n  border-left: 5px solid #00703C;\n}\n\n.mission-card h3 {\n  color: #00703C;\n  font-size: 1.8rem;\n  margin-bottom: 1.5rem;\n  font-weight: 700;\n}\n\n.mission-card p {\n  color: #555;\n  line-height: 1.8;\n  font-size: 1.05rem;\n}\n\n/* ===== Responsive Design ===== */\n@media (max-width: 768px) {\n  .hero-section {\n    height: 70vh;\n  }\n\n  .hero-title {\n    font-size: 2rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1.1rem;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n    max-width: 300px;\n    justify-content: center;\n  }\n\n  .slider-btn {\n    width: 40px;\n    height: 40px;\n  }\n\n  .slider-btn.prev {\n    left: 1rem;\n  }\n\n  .slider-btn.next {\n    right: 1rem;\n  }\n\n  .stats-container {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .stat-number {\n    font-size: 2.5rem;\n  }\n\n  .section-header h2 {\n    font-size: 2rem;\n  }\n\n  .intro-section,\n  .features-section,\n  .cta-section,\n  .mission-section {\n    padding: 3rem 1rem;\n  }\n\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mission-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .cta-content h2 {\n    font-size: 2rem;\n  }\n\n  .cta-content p {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 1.6rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .stat-number {\n    font-size: 2rem;\n  }\n\n  .section-header h2 {\n    font-size: 1.7rem;\n  }\n\n  .feature-icon {\n    width: 60px;\n    height: 60px;\n  }\n\n  .mission-card {\n    padding: 2rem 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
